<template>
  <form>
    <!-- 車牌號碼輸入框 -->
    <div>
      <div class="form-title-container">
        <p>車牌號碼</p>
        <div
          class="licensePlateNumber"
          :class="{ 'is-over': isLicenseNumberOver }"
        >
          <span>{{ licenseNumberLength }}</span>
          <span>/</span>
          <span>{{ licenseNumberLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：ABC-1234"
        v-model="engraving_content.content.commemorativeLicensePlateNumber"
      />
    </div>
    <!-- 車牌圖片下拉選單 -->
    <div class="dropdown_title">
      <p class="title">車牌圖片</p>
      <a href="#" v-on:click.prevent="showDropDown = !showDropDown">
        <div class="title">{{ getImageOptionLabel }}</div>
        <i
          :class="{
            'fa-caret-up': showDropDown,
            'fa-caret-down': !showDropDown,
          }"
          class="fa"
          aria-hidden="true"
        ></i>
      </a>
      <transition name="slide-fade">
        <div class="choice" v-if="showDropDown">
          <ul>
            <li v-for="(option, index) in imageOptions" :key="index">
              <span v-on:click="updateImageOption(option.value)">{{
                option.label
              }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- 車牌圖片選擇純文字 - 輸入框 -->
    <div
      v-if="
        engraving_content.content.commemorativeLicensePlateImageOption ===
        'text'
      "
    >
      <div class="form-title-container">
        <p>文字</p>
        <div
          class="licensePlateImageText"
          :class="{ 'is-over': isImageTextOver }"
        >
          <span>{{ imageTextLength }}</span>
          <span>/</span>
          <span>{{ commemorativeLicensePlateImageText }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：王大明"
        v-model="engraving_content.content.commemorativeLicensePlateImageText"
      />
    </div>
    <!-- 車牌圖片選擇自訂 - 輸入框 -->
    <div
      v-if="
        engraving_content.content.commemorativeLicensePlateImageOption ===
        'custom'
      "
    >
      <div class="form-title-container">
        <p>圖片敘述</p>
        <div
          class="licensePlateImageCustom"
          :class="{ 'is-over': isImageCustomOver }"
        >
          <span>{{ imageCustomLength }}</span>
          <span>/</span>
          <span>{{ commemorativeLicensePlateImageCustom }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：XXX品牌Logo"
        v-model="engraving_content.content.commemorativeLicensePlateImageCustom"
      />
      <p>製圖人員會依照您提供的圖片敘述作為後續與你討論完稿的依據。</p>
    </div>
    <!-- 反面文字 -->
    <div>
      <div class="form-title-container">
        <p>反面文字</p>
        <div
          class="licensePlateReverseText"
          :class="{ 'is-over': isReverseTextOver }"
        >
          <span>{{ reverseTextLength }}</span>
          <span>/</span>
          <span>{{ commemorativeLicensePlateReverseText }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：福祿壽喜財"
        v-model="engraving_content.content.commemorativeLicensePlateReverseText"
      />
    </div>
    <p class="note">畫面呈現為示意圖，正式製作稿件將由專業人員編排製版完成。</p>
  </form>
</template>
<script>
import {
  engravingDefaultContent,
  commemorativeLicensePlateImageOptions,
} from "@/constData/engravingData";

export default {
  name: "MetalTextCommemorativeLicensePlate",
  data() {
    return {
      showDropDown: false,
      imageOptions: commemorativeLicensePlateImageOptions,
      engraving_content: {
        type: "commemorative_license_plate",
        content: {
          commemorativeLicensePlateNumber: "",
          commemorativeLicensePlateImageOption: "nothing",
          commemorativeLicensePlateImageText: "",
          commemorativeLicensePlateImageCustom: "",
          commemorativeLicensePlateReverseText: "",
        },
      },
      // 字數限制（從 store 讀取）
      licenseNumberLimit: 0,
      commemorativeLicensePlateImageText: 0,
      commemorativeLicensePlateImageCustom: 0,
      commemorativeLicensePlateReverseText: 0,
    };
  },
  created() {
    // 從 store 讀取現有資料或使用預設值
    const storeContent = this.$store.getters.currentCustom.engraving_content;

    if (storeContent.type === "commemorative_license_plate") {
      this.engraving_content = storeContent;
    } else {
      this.engraving_content.content = {
        ...engravingDefaultContent.commemorative_license_plate,
      };
    }

    // 獲取字數限制配置
    let componentCode = this.$store.getters.getComponentCode;
    let textLimit =
      this.$store.getters.textSettingByComponentCode(componentCode);

    // 計算總字數限制
    this.licenseNumberLimit =
      textLimit.commemorativeLicensePlateNumber.lineLimit *
      textLimit.commemorativeLicensePlateNumber.textLimit;
    this.commemorativeLicensePlateImageText =
      textLimit.commemorativeLicensePlateImageText.lineLimit *
      textLimit.commemorativeLicensePlateImageText.textLimit;
    this.commemorativeLicensePlateImageCustom =
      textLimit.commemorativeLicensePlateImageCustom.textLimit;
    this.commemorativeLicensePlateReverseText =
      textLimit.commemorativeLicensePlateReverseText.textLimit;
  },
  computed: {
    // 取得當前選項的 label 文字
    getImageOptionLabel() {
      const option = this.imageOptions.find(
        (opt) =>
          opt.value ===
          this.engraving_content.content.commemorativeLicensePlateImageOption
      );
      return option ? option.label : "";
    },
    // 字數計數
    licenseNumberLength() {
      return this.engraving_content.content.commemorativeLicensePlateNumber
        .length;
    },
    imageTextLength() {
      return this.engraving_content.content.commemorativeLicensePlateImageText
        .length;
    },
    imageCustomLength() {
      return this.engraving_content.content.commemorativeLicensePlateImageCustom
        .length;
    },
    reverseTextLength() {
      return this.engraving_content.content.commemorativeLicensePlateReverseText
        .length;
    },
    // 是否超過限制
    isLicenseNumberOver() {
      return this.licenseNumberLength > this.licenseNumberLimit;
    },
    isImageTextOver() {
      return this.imageTextLength > this.commemorativeLicensePlateImageText;
    },
    isImageCustomOver() {
      return this.imageCustomLength > this.commemorativeLicensePlateImageCustom;
    },
    isReverseTextOver() {
      return this.reverseTextLength > this.commemorativeLicensePlateReverseText;
    },
    // 是否有任何欄位超過限制
    isAnyFieldOver() {
      // 檢查車牌號碼
      if (this.isLicenseNumberOver) return true;

      // 檢查反面文字
      if (this.isReverseTextOver) return true;

      // 只在選擇「純文字」時檢查圖片文字
      if (
        this.engraving_content.content.commemorativeLicensePlateImageOption ===
          "text" &&
        this.isImageTextOver
      ) {
        return true;
      }

      // 只在選擇「自訂」時檢查圖片敘述
      if (
        this.engraving_content.content.commemorativeLicensePlateImageOption ===
          "custom" &&
        this.isImageCustomOver
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    "engraving_content.content": {
      handler() {
        this.updateCostom();
      },
      deep: true,
    },
  },
  methods: {
    updateCostom() {
      let payload = {
        key: "engraving_content",
        content: this.engraving_content,
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateImageOption(value) {
      this.engraving_content.content.commemorativeLicensePlateImageOption =
        value;

      // 切換選項時清空相關欄位
      if (value !== "text") {
        this.engraving_content.content.commemorativeLicensePlateImageText = "";
      }
      if (value !== "custom") {
        this.engraving_content.content.commemorativeLicensePlateImageCustom =
          "";
      }

      this.updateCostom();
      this.showDropDown = false;
    },
    checkoutTextLimit() {
      return this.isAnyFieldOver ? "over" : "ok";
    },
  },
};
</script>
<style scoped lang="scss">
.licensePlateNumber,
.licensePlateImageText,
.licensePlateImageCustom,
.licensePlateReverseText {
  color: #4a4a4a;
  transition: color 0.2s ease;

  &.is-over {
    color: red;
  }
}
</style>
